// Fragment NÉERLANDAIS du lot « règles » : Règles du jeu (/regles-de-jeu, cible
// du QR code de la boîte), Commande réussie (/success) et page 404.
// COHÉRENCE : les questions 5, 7 et 11 sont reprises à l'identique dans
// nl/experience.js (demo.question.*) — toute retouche ici doit y être
// répercutée. La question subsidiaire de la démo (demo.subsidiaire.question)
// est VOLONTAIREMENT différente : l'accueil ne dévoile jamais la vraie.
// À VÉRIFIER avec l'imprimeur : si un guide néerlandais est livré dans la
// boîte, ces 11 questions doivent en reprendre le libellé exact.
// NB : la réponse à la question subsidiaire n'a volontairement PAS de clé :
// elle ne doit exister que dans GameRules.jsx, derrière le clic
// « parents uniquement ».
export default {
  // --- Règles du jeu : SEO ---
  'regles.seo.titre': 'Spelregels van Joyful Reveal',
  'regles.seo.description':
    'De volledige spelregels van het gender reveal-spel Joyful Reveal: vorm twee teams, beantwoord de 11 vragen, leg samen de puzzel en kras het laatste stukje open dat het geslacht van de baby onthult.',

  // --- Règles du jeu : en-tête ---
  'regles.entete.titre': 'De spelregels',
  'regles.entete.introAvant':
    'Twee teams, 11 vragen, een puzzel om te leggen en een laatste stukje om te krassen. Reken op ongeveer',
  'regles.entete.introDuree': '20 minuten',
  'regles.entete.introEntre': ', voor',
  'regles.entete.introJoueurs': '2 tot 10 spelers',

  // --- Règles du jeu : avertissement invités ---
  'regles.invite.titre': '🤫 Bent u uitgenodigd voor een feest?',
  'regles.invite.destinee': 'Deze pagina is bedoeld voor de',
  'regles.invite.parents': 'aanstaande ouders',
  'regles.invite.suite':
    'die het spel voorbereiden. Bent u speler? Sluit deze pagina dan: u zou uw eigen verrassing bederven!',

  // --- Règles du jeu : contenu du kit ---
  'regles.kit.titre': '🎁 Wat uw kit bevat',
  'regles.kit.sachetAvant': 'Een hoofdzakje met daarin',
  'regles.kit.sachetPieces': '11 puzzelstukjes',
  'regles.kit.grattoirAvant': 'en',
  'regles.kit.grattoirPiece': 'één uniek stukje om te krassen',
  'regles.kit.grattoirFin': '— het stukje dat alles onthult.',
  'regles.kit.premium':
    'Het Pack Premium voegt daar de twee katoenen zakjes van de teams aan toe, de vragenlijst gedrukt op karton van 400 g en de herinneringsenvelop die u na het feest achter een fotolijstje schuift.',

  // --- Règles du jeu : les 4 étapes ---
  'regles.etape1.titre': 'Voordat de gasten arriveren',
  'regles.etape1.alt':
    'De inhoud van het spel Joyful Reveal uitgestald: de doos, de vragenlijst en de twee katoenen zakjes',
  'regles.etape1.p1':
    'De aanstaande ouders kiezen de 11 vragen die de spelers moeten beantwoorden. Bij elk juist antwoord wordt een puzzelstukje gewonnen.',
  'regles.etape1.p2':
    'Het antwoord is altijd “mama” of “papa” — en dat is natuurlijk met een flinke knipoog bedoeld!',
  'regles.etape1.p3':
    'U kunt onze kant-en-klare lijst gebruiken (verderop) of uw eigen vragen bedenken met het blanco sjabloon.',

  'regles.etape2.titre': 'Vorm de twee teams',
  'regles.etape2.alt': 'De twee katoenen zakjes van het spel, met het label Team 1 en Team 2',
  'regles.etape2.p1': 'Verdeel uw gasten over twee teams — bijvoorbeeld:',
  'regles.etape2.equipe1Label': 'Team 1',
  'regles.etape2.equipe1Texte': 'degenen die denken dat de baby een meisje zal zijn 💗',
  'regles.etape2.equipe2Label': 'Team 2',
  'regles.etape2.equipe2Texte': 'degenen die denken dat de baby een jongen zal zijn 💙',

  'regles.etape3.titre': 'Het spel: de 11 stukjes winnen',
  'regles.etape3.alt':
    'Achterkant van de doos Joyful Reveal met een overzicht van de 4 stappen van het spel',
  'regles.etape3.p1':
    'De aanstaande ouders stellen de vragen één voor één. Het team dat als eerste het juiste antwoord geeft, wint een puzzelstukje.',
  'regles.etape3.p2': 'Zo gaat het door voor de 11 klassieke stukjes van de puzzel.',
  'regles.etape3.p3':
    'Zodra de 11 stukjes gewonnen zijn, werken de twee teams samen om de puzzel te leggen… en dan ontbreekt er nog maar één stukje!',

  'regles.etape4.titre': 'Het laatste stukje: de grote onthulling',
  'regles.etape4.alt': 'De doos van het spel Joyful Reveal met het puzzelstukje om te krassen',
  'regles.etape4.p1':
    'Alleen het team dat de meeste stukjes heeft gewonnen, mag deze laatste speelfase spelen — en deze keer speelt elke speler individueel.',
  'regles.etape4.p2':
    'De aanstaande ouders stellen dan de schiftingsvraag. De speler wiens gok het antwoord het dichtst benadert, wint het laatste puzzelstukje… en het voorrecht om het open te krassen!',

  // --- Règles du jeu : question subsidiaire (la réponse reste dans le JSX) ---
  'regles.subsidiaire.surtitre': 'De schiftingsvraag',
  'regles.subsidiaire.question':
    '“Hoeveel wegwerpluiers gebruiken jonge ouders gemiddeld in het eerste levensjaar van hun baby?”',
  'regles.subsidiaire.reponseLabel': 'Antwoord:',
  'regles.subsidiaire.bouton': '👀 Antwoord tonen (alleen voor de ouders)',
  'regles.subsidiaire.libre':
    'Het is onze favoriete vraag — maar kies gerust uw eigen vraag: het antwoord moet gewoon een te schatten getal zijn.',

  // --- Règles du jeu : le conseil ---
  'regles.conseil.surtitre': '💡 Klein advies',
  'regles.conseil.titre': 'Weersta de verleiding om uw gasten te waarschuwen!',
  'regles.conseil.texte':
    'Stel u hun reactie eens voor wanneer ze het spel ontdekken en beseffen dat ze op het punt staan een uniek moment vol spanning te beleven. Het is echt de moeite waard om hun gezichten te zien oplichten. Dus houd vol en verklap uw geheim niet!',

  // --- Règles du jeu : les 11 questions ---
  'regles.questions.titre': '📝 De 11 kant-en-klare vragen',
  'regles.questions.imprimer': '🖨️ Afdrukken',
  'regles.questions.q1': 'Wie is de beste kok voor het bereiden van babypuree?',
  'regles.questions.q2': 'Wie raakt het meest waarschijnlijk in paniek tijdens de bevalling?',
  'regles.questions.q3':
    'Wie onthoudt gemakkelijker de geboortelengte en het geboortegewicht van de baby?',
  'regles.questions.q4': 'Wie heeft de meeste moeite met het verschonen van babyluiers?',
  'regles.questions.q5': 'Wie zal de slaapliedjes rampzalig zingen?',
  'regles.questions.q6':
    'Wie kan er niet aan weerstaan om schattige maar nutteloze kleertjes te kopen?',
  'regles.questions.q7': 'Wie zal huilen bij kinderfilms?',
  'regles.questions.q8': 'Wie trekt de beste gezichten om de baby aan het lachen te maken?',
  'regles.questions.q9':
    'Wie begrijpt waarschijnlijk niet hoe je een baby kleding moet aantrekken?',
  'regles.questions.q10': 'Wie is de beste verhalenverteller om baby in slaap te brengen?',
  'regles.questions.q11':
    'Wie zou de baby onhandig wakker maken door op een lawaaierig speeltje te stappen?',
  'regles.questions.persoAvant':
    'Zin om te personaliseren? Vervang deze vragen gerust door uw eigen vragen — het belangrijkste is dat er maar twee antwoorden mogelijk blijven:',
  'regles.questions.persoMaman': '“mama”',
  'regles.questions.persoOu': 'of',
  'regles.questions.persoPapa': '“papa”',
  'regles.questions.persoFin': '. Het Pack Premium bevat een blanco sjabloon dat daarvoor gemaakt is.',

  // --- Règles du jeu : CTA final ---
  'regles.cta.titre': 'Nog geen spel in huis?',
  'regles.cta.texte': 'Veel plezier — en nogmaals proficiat, aanstaande ouders! 🎉',
  'regles.cta.bouton': '🛒 Ontdek het spel',

  // --- Page 404 (NotFound.jsx), rangée sous « regles » faute d'espace dédié ---
  'regles.introuvable.seoTitre': '404 - Pagina niet gevonden',
  'regles.introuvable.seoDescription':
    'De pagina die u zoekt, bestaat niet. Ga terug naar de startpagina of ontdek onze shop.',
  'regles.introuvable.titre': '404 - Oeps!',
  'regles.introuvable.sousTitre': 'De pagina die u zoekt, konden we niet vinden.',
  'regles.introuvable.texte':
    'Misschien is de pagina verwijderd of verplaatst, of klopt de URL niet.',
  'regles.introuvable.boutonAccueil': '🏠 Terug naar de startpagina',
  'regles.introuvable.boutonBoutique': '🛍️ Naar de shop',
  'regles.introuvable.aide': 'Hulp nodig?',
  'regles.introuvable.aideLien': 'Neem contact op',

  // --- Commande réussie (Success.jsx) ---
  'succes.chargement.titre': 'Uw bestelling wordt afgerond...',
  'succes.chargement.texte': 'We halen uw trackingnummer op, dat duurt niet lang.',
  'succes.entete.titre': 'Bestelling geslaagd!',
  'succes.entete.numeroLabel': 'Bestelnummer:',
  'succes.entete.merci':
    'Bedankt voor uw aankoop! U ontvangt een bevestigingsmail met de details van uw bestelling en uw factuur.',
  'succes.suivi.titre': 'Uw pakje volgen',
  'succes.suivi.etiquette': 'Uw verzendlabel is aangemaakt!',
  'succes.suivi.numeroLabel': 'Trackingnummer:',
  'succes.suivi.bouton': '🚚 Mijn pakje volgen',
  'succes.suivi.astuce':
    '💡 U vindt deze link ook terug in uw profiel → Mijn bestellingen',
  'succes.attente.texte':
    'Uw bestelling wordt verwerkt. Het trackingnummer verschijnt binnenkort in uw klantenruimte.',
  // Downloadbare spelgids. Bevat het antwoord op de schiftingsvraag : de
  // waarschuwing is geen decoratie.
  // Affiché quand la session de paiement n'est plus lisible (lien rouvert
  // des semaines plus tard) : la page restait alors amputée EN SILENCE —
  // ni numéro de commande, ni guide, ni facture, et aucune explication.
  'succes.introuvable.texte':
    "Uw betaling is gelukt. We kunnen de details van deze bestelling hier alleen niet tonen — dat gebeurt wanneer deze link later opnieuw wordt geopend. Uw bevestigingsmail bevat uw bestelnummer en uw factuur; schrijf ons als u die niet terugvindt.",
  'succes.guide.titre': 'Uw spelgids',
  'succes.guide.texte':
    'Het volledige boekje, met de 11 kant-en-klare vragen en het blanco sjabloon om uw eigen vragen te schrijven. Hou het bij de hand op de grote dag.',
  'succes.guide.bouton': '📥 Gids downloaden (PDF)',
  'succes.guide.avertissement':
    '⚠️ Alleen voor de aanstaande ouders : het verklapt het antwoord op de schiftingsvraag.',

  'succes.questionnaire.titre': 'Uw herinneringsquiz',
  'succes.questionnaire.texte':
    'Het printklare quizblad, in hetzelfde formaat als de kaart in het spel: de 11 vragen en de teamkolommen. Vink het vakje aan voor een blanco versie, in te vullen met uw eigen vragen.',
  'succes.questionnaire.vierge': 'Blanco versie (om uw eigen vragen te schrijven)',
  'succes.questionnaire.bouton': '📥 De quizfiche downloaden (PDF)',
  'succes.questionnaire.avertissement':
    '⚠️ Alleen voor de aanstaande ouders : de achterkant verklapt het antwoord op de schiftingsvraag.',

  "succes.facture.titre": "Uw factuur",
  "succes.facture.texte":
    "De factuur van uw bestelling (in het Frans) staat klaar. Stripe stuurt u daarnaast een betalingsbewijs per e-mail.",
  "succes.facture.bouton": "🧾 Factuur bekijken en afdrukken",
  'succes.avis.titre': 'Uw beoordeling telt!',
  'succes.avis.texte': 'Deel uw ervaring en help andere klanten om onze producten te ontdekken.',
  'succes.avis.bouton': '✍️ Een beoordeling schrijven',
  'succes.actions.commandes': '📋 Mijn bestellingen bekijken',
  'succes.actions.boutique': '🎮 Verder winkelen',
};
